import { extractClassicAppsBaseUrl } from '../../helpers/study.helpers';
export const buildDocumentUrl = (documentId, environment) => {
    if (!environment) {
        return '';
    }
    const appUrl = extractClassicAppsBaseUrl(environment.cortexURL, 'site');
    return `${appUrl}/documents/${documentId}?orgCode=${environment.code}`;
};
export const buildDocumentCreateUrl = (participantId, environment, manualUserSelection = false) => {
    if (!environment || !participantId) {
        return '';
    }
    const appUrl = extractClassicAppsBaseUrl(environment.cortexURL, 'site');
    const createDocumentURL = `${appUrl}/documents/create`;
    if (manualUserSelection) {
        return `${createDocumentURL}?orgCode=${environment.code}`;
    }
    return `${createDocumentURL}/participant/${participantId}?orgCode=${environment.code}`;
};
